import React from 'react';
import { Box, Typography, Grid, Skeleton, Divider } from '@mui/material';

const SkeletonFeedCard = ({ removeBanner }: { removeBanner?: boolean }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          position: 'relative',
          '&:after': {
            content: '""',
            display: 'table',
            clear: 'both'
          }
        }}
        margin="24px 0 36px 0"
      >
        <Box
          sx={{
            width: '100%',
            '@media (max-width: 540px)': {
              width: '100%'
            }
          }}
        >
          {removeBanner ? null : (
            <Box
              marginTop="0px"
              marginBottom="0"
              display="block"
              sx={{
                marginTop: '-16px !important',
                marginLeft: '-16px !important',
                marginRight: '-16px !important'
              }}
              position="sticky"
              top="0"
            >
              <Skeleton
                width="100%"
                height={82}
                sx={{
                  marginTop: '0px',
                  borderRadius: '0px'
                }}
              />
            </Box>
          )}

          <Typography component="div" variant="caption">
            <Skeleton
              width={200}
              sx={{
                marginTop: '0px'
              }}
            />
          </Typography>
          <Box>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{
                  textAlign: 'center'
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    right: '0'
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="right"
                  >
                    <Skeleton
                      variant="circular"
                      height={40}
                      width={40}
                      sx={{
                        marginRight: '4px'
                      }}
                    />
                    <Skeleton
                      variant="circular"
                      height={40}
                      width={40}
                      sx={{
                        marginRight: '4px'
                      }}
                    />
                    <Skeleton
                      variant="circular"
                      height={40}
                      width={40}
                      sx={{
                        marginRight: '4px'
                      }}
                    />
                    <Skeleton
                      variant="circular"
                      height={40}
                      width={40}
                      sx={{
                        marginRight: '4px'
                      }}
                    />
                  </Box>
                </Box>

                <Box display="flex" justifyContent="center" marginTop="16px">
                  <Skeleton
                    variant="rectangular"
                    height={300}
                    sx={{
                      marginTop: `10px`,
                      marginBottom: '1rem',
                      width: '200px',
                      lg: {
                        width: '300px',
                        marginTop: `10px`,
                        marginBottom: '1rem'
                      }
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Box display="block">
                  <Skeleton
                    variant="rectangular"
                    height={16}
                    width="100%"
                    sx={{
                      marginBottom: '10px'
                    }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={16}
                    width={150}
                    sx={{
                      marginBottom: '10px'
                    }}
                  />
                </Box>
                <Skeleton
                  variant="rectangular"
                  height={200}
                  width="100%"
                  sx={{
                    marginBottom: '10px'
                  }}
                />
                <Box>
                  <Skeleton
                    variant="rectangular"
                    height={16}
                    width="100%"
                    sx={{
                      marginBottom: '10px'
                    }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={16}
                    width="64%"
                    sx={{
                      marginBottom: '8px'
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Divider />
    </>
  );
};

export default SkeletonFeedCard;
